import React, { useState } from 'react';
import classNames from 'classnames';
import './MatrixListItemPublic.scss';

// TODO these should be removed if we are sure we don't want them
const descriptions = {
  'Learning modules':
    'Expand your understanding of ecosystem and interspecies dynamics with our education modules',
  'MPG Grasslands':
    'Dig deeper into the matrix using this grassland ecosystem to understand the complexities of management actions between and within trophic levels',
  'Lake trout introduction to Yellowstone Lake':
    'See how illegally introduced lake trout impacts the ecosystem in Yellowstone Lake',
  'Red squirrel introduction to Newfoundland':
    'Understand how intentional red squirrel introduction affects other ecosystem players in Newfoundland',
  'Simple Ecosystem':
    'Explore the fundamentals behind the matrix with a simple ecosystem structure',
};

// Education list items should already be fetched from the public list
// because that's necessary to reorder them
const MatrixListItemPublic = ({ matrix, onClick }) => {
  const [isListItemHovered, setListItemHovered] = useState(false);

  const clickItem = e => {
    onClick(e);
  };

  return (
    <>
      <div
        className={classNames('MatrixListItemPublic', `id${matrix.id}`, {
          highlighted: isListItemHovered,
        })}
        onClick={clickItem}
        onMouseEnter={() => setListItemHovered(true)}
        onMouseLeave={() => setListItemHovered(false)}
      >
        <div className="MatrixListItemPublic-image">
          {matrix.imageUrl ? (
            <img draggable="false" src={matrix.imageUrl} alt="" />
          ) : (
            <div className="MatrixListItemPublic-blank-filler" />
          )}
        </div>
        <div className="MatrixListItemPublic-text-container">
          <div className="MatrixListItemPublic-text-title">{matrix.name}</div>
          <div
            className="MatrixListItemPublic-text-description"
            title={
              matrix?.description && matrix?.description !== ''
                ? matrix?.description
                : null
            }
          >
            {matrix?.description && matrix?.description !== ''
              ? matrix?.description
              : null}
          </div>
        </div>
      </div>
    </>
  );
};
export default MatrixListItemPublic;
